import { render, staticRenderFns } from "./MatchCommit.vue?vue&type=template&id=755fa8a9&scoped=true&"
import script from "./MatchCommit.vue?vue&type=script&lang=ts&"
export * from "./MatchCommit.vue?vue&type=script&lang=ts&"
import style0 from "./MatchCommit.vue?vue&type=style&index=0&id=755fa8a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755fa8a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VBtn,VContainer,VFooter})
